import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { expandCollapse } from '../_shared';

@Component({
  moduleId: module.id.toString(),
  selector: 'report-overview-panel-v3',
  templateUrl: './templates/report-overview-panel-v3.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [expandCollapse],
})
export class ReportOverviewPanelV3Component {
  @Input() title: string = '';
  @Input() loading: boolean = false;
  @Input() isEmpty: boolean = false;
  @Input() expanded: boolean = false;

  @Output() expandedChange = new EventEmitter<boolean>();

  toggle() {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
